import React, { useState } from "react";
import PropTypes from "prop-types";
import * as AuthenticationProvider from "./../../../modules/AuthenticationProvider";
import { useUserSettings } from "../../../context/CurrentUserContext";
import { FormularioLogin } from "../Formulario/container";
import { InitialRouteByProfile } from "./initialPagePerfil";

export const LoginScreenContainer = props => {
 
  let [redirect, setRedirect] = useState(false)

  const { setCurrentUser } = useUserSettings();

  function loginSuccessRedirect() {
    setRedirect(true)
  }

  const handleSignInCompleted = () => {
    setCurrentUser(AuthenticationProvider.userData());
    loginSuccessRedirect();
  };

  return redirect ? (<InitialRouteByProfile/>)
  :(
    <FormularioLogin onSignInCompleted={handleSignInCompleted}/>
  );
};

LoginScreenContainer.propTypes = {
  history: PropTypes.object
};

export default LoginScreenContainer;